import { useContext, useEffect } from 'react'
import PromotedBranchStore from '../../../components/promote_changes/context/context'
import DeletePromotedFiles from '../../../components/promote_changes/delete_files'
import { NavContext } from '../../../context/global_context'
import { useParams } from 'react-router-dom'

const DeletePromotedChangesPage = () => {
  const { vehicle, branch } = useParams()

  const [navState, navDispatch] = useContext(NavContext)

  useEffect(() => {
    navDispatch({
      type: 'header',
      data: {
        header: `${branch} - ${vehicle}`,
        sub_header: 'You can delete promoted files using this tool.',
        id: '',
        show_back_btn: true,
        dtc_details: {},
        back_btn_url: `/manage-update-list`,
        full_width_container: false,
      },
    })
  }, [])
  return (
    <PromotedBranchStore>
      <DeletePromotedFiles />
    </PromotedBranchStore>
  )
}

export default DeletePromotedChangesPage
